import { useState, useRef } from "react";
import Button from "./Button";
import { trackLink } from "utils/analytics";

const Feedback = ({ module }) => {
	const feedbackProvidedMessageRef = useRef(null);
	const mainClass = "help-feedback";
	const [feedbackProvided, setFeedbackProvided] = useState(false);
	const [message, setMessage] = useState(module.defaultMessage);
	const provideFeedback = (linkId, message) => {
		trackLink({ linkId });
		setMessage(message);
		setFeedbackProvided(true);
		feedbackProvidedMessageRef.current &&
			feedbackProvidedMessageRef.current.focus();
	};

	return module ? (
		<div
			ref={feedbackProvidedMessageRef}
			tabIndex="-1"
			className={`${mainClass}__container`}
			role="presentation"
			aria-label={message}
		>
			<div className={`${mainClass}__message-block`}>
				<p className={`${mainClass}__message`}>{message}</p>
			</div>
			{!feedbackProvided && (
				<div className={`${mainClass}__button-block`}>
					{module.buttons.map((buttonOptions, index) => (
						<Button
							key={index}
							title={buttonOptions.title}
							secondary={true}
							className={`${mainClass}__${module.buttonContainerSelector} ${mainClass}__${module.buttonContainerSelector}--${buttonOptions.selector}`}
							onClick={() =>
								provideFeedback(buttonOptions.linkId, buttonOptions.message)
							}
						></Button>
					))}
				</div>
			)}
		</div>
	) : null;
};

export default Feedback;
